export default __webpack_public_path__ + "ui/assets/img/status-success.jpg";